import React from 'react';
import Hero from './components/about-us/history/Hero';
import Main from './components/about-us/history/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const History = () => {
  return (
    <div>
        <Hero />
        <Main />
        <ImportantLinksSlider />
    </div>
  )
}

export default History;